import { useContext } from "react";
import { AppContext } from "../App";
import logo from "../assets/logo.png";
import { MdClose, MdHome, MdInfoOutline, MdSpa, MdPublic, MdVerifiedUser, MdPhone } from "react-icons/md";

export default function SideBar() {
  const appContext = useContext(AppContext);

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item) {
    appContext.navTo({ item });
    if (appContext.isSideBarOpen) {
      closeSideBar();
    }
  }

  const items = [
    { key: "home", label: "Home", icon: <MdHome size={20} /> },
    { key: "about_us", label: "About Us", icon: <MdInfoOutline size={20} /> },
    { key: "services", label: "Services", icon: <MdPublic size={20} /> },
    { key: "contact_us", label: "Contact Us", icon: <MdPhone size={20} /> },
  ];

  return (
    <>
      <style>{`
        .SideBar {
          background: var(--bg-primary);
          border-right: 1px solid rgba(0, 0, 0, 0.05);
          transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
        }

        .side-modern-body {
          display: flex;
          flex-direction: column;
          padding: 1.5rem;
          background: linear-gradient(180deg, rgba(255,255,255,0.8) 0%, var(--bg-primary) 100%);
          backdrop-filter: blur(12px);
        }

        .side-modern-head {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 0.5rem;
        }

        .side-modern-close {
          background: rgba(0, 0, 0, 0.03);
          border: none;
          color: var(--text-primary);
          padding: 8px;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .side-modern-close:hover {
          background: var(--bg-secondary);
          color: var(--text-secondary);
        }

        .side-modern-brand {
          text-align: center;
          padding: 0.5rem 0 2rem 0;
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          margin-bottom: 2rem;
        }

        .side-modern-brand-logo img {
          width: 55px;
          height: auto;
          filter: drop-shadow(0 4px 8px rgba(0,0,0,0.08));
          margin-bottom: 0.75rem;
        }

        .side-modern-brand-name {
          font-size: 1.1rem;
          letter-spacing: 1.5px;
          color: var(--text-primary);
          margin: 0;
          text-transform: uppercase;
          font-weight: 800;
        }

        .side-modern-brand-tag {
          font-size: 0.65rem;
          color: var(--text-primary);
          opacity: 0.5;
          margin-top: 4px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .side-modern-nav {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .side-modern-item {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 14px 18px;
          border-radius: 12px;
          background: transparent;
          color: var(--text-primary);
          cursor: pointer;
          transition: all 0.3s ease;
          text-align: left;
          width: 100%;
          border: 1px solid transparent;
        }

        .side-modern-item-icon {
          display: flex;
          align-items: center;
          opacity: 0.6;
        }

        .side-modern-item-label {
          font-weight: 500;
          font-size: 0.9rem;
        }

        .side-modern-item:hover {
          background: rgba(0, 0, 0, 0.02);
          transform: translateX(5px);
        }

        .side-modern-item[data-active="true"] {
          background: var(--bg-secondary);
          color: var(--text-secondary);
          box-shadow: 0 8px 15px rgba(0,0,0,0.05);
        }

        .side-modern-item[data-active="true"] .side-modern-item-icon {
          opacity: 1;
        }

        .side-modern-item[data-active="true"] .side-modern-item-label {
          font-weight: 700;
        }
      `}</style>

      <aside className="SideBar" data-open={appContext.isSideBarOpen} aria-label="Sidebar navigation">
        <div className="body mNoScrollBar side-modern-body">
          <div className="side-modern-head">
            <button type="button" className="side-modern-close" onClick={appContext.closeSideBar} aria-label="Close menu">
              <MdClose size={22} />
            </button>
          </div>

          <div className="side-modern-brand">
            <div className="side-modern-brand-logo">
              <img src={logo} alt="THAI H&K logo" />
            </div>
            <p className="side-modern-brand-name">Thai H&K Trading</p>
            <p className="side-modern-brand-tag">Premium Tanzanian Produce</p>
          </div>

          <nav className="side-modern-nav" aria-label="Main">
            {items.map((item) => {
              const isActive = !appContext.navItem ? item.key === "home" : appContext.navItem === item.key;
              return (
                <button
                  key={item.key}
                  type="button"
                  className="side-modern-item"
                  onClick={() => goTo(item.key)}
                  data-active={isActive}
                >
                  <span className="side-modern-item-icon" aria-hidden="true">
                    {item.icon}
                  </span>
                  <span className="side-modern-item-label">{item.label}</span>
                </button>
              );
            })}
          </nav>
        </div>
      </aside>
    </>
  );
}